import { Tooltip as CTooltip } from 'antd';
import React, { useState } from 'react';

export type Cplacement = 'top' | 'left' | 'right' | 'bottom' | 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight' | 'leftTop' | 'leftBottom' | 'rightTop' | 'rightBottom';

interface ITooltipProps {
    children?: React.ReactNode;
    placements: Cplacement;
    title: string | React.ReactNode;
    colorCustom?: string;
    overlayClassName?: string;
}

const Tooltip: React.FC<ITooltipProps> = ({
    children, placements = 'topLeft', title, colorCustom = '#001529', overlayClassName
}) => {
    return (
        <CTooltip
            fresh
            className='tooltip'
            placement={placements}
            title={title}
            color={colorCustom}
            overlayClassName={overlayClassName}
            zIndex={1000}
            autoAdjustOverflow
            trigger="hover"
            destroyTooltipOnHide
        >{children}</CTooltip>
    )
};

export default Tooltip;
